import { TranslateService } from '@ngx-translate/core';
import { Pipe, PipeTransform, LOCALE_ID, Inject } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'niceDate',
  standalone: false,
})
export class NiceDatePipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    @Inject(LOCALE_ID) private locale: string
  ) {}

  public transform(value: any, timezone?: string): string {
    const date = new Date(value);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    if (this.sameDay(today, date)) {
      return formatDate(date, 'HH:mm', this.locale);
    } else if (this.sameDay(yesterday, date)) {
      return this.translateService.instant('niceDate.yesterday', { value: formatDate(date, 'HH:mm', this.locale) });
    } else {
      return this.translateService.instant('niceDate.anotherDay', {
        date: formatDate(date, 'dd/LL', this.locale),
        heure: formatDate(date, 'HH:mm', this.locale),
      });
    }
  }

  private sameDay(d1: Date, d2: Date) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
  }
}
